import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Markdown from "markdown-to-jsx";
import { Fragment } from "react";
import { isCmsTag } from "../packages/types/src/guards/config.js";
import Tooltip from "../Tooltip/Tooltip.js";
const StyledHelpIcon = styled(HelpIcon)(({
  theme
}) => ({
  "&.MuiSvgIcon-root": {
    color: theme.colors.icon.primary,
    fontSize: theme.fonts.size.sm,
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: theme.sizes.spacing["02"],
    verticalAlign: "middle"
  }
}));
const asFooter = styled(Box)(({
  theme
}) => ({
  padding: `${theme.sizes.spacing["03"]} ${theme.sizes.spacing["07"]} ${theme.sizes.spacing.none} ${theme.sizes.spacing["07"]}`,
  margin: `${theme.sizes.spacing.none} -${theme.sizes.spacing["07"]} -${theme.sizes.spacing["03"]} -${theme.sizes.spacing["07"]}`,
  borderTop: `${theme.sizes.borderWidth[1]} solid ${theme.colors.border.primary}`,
  position: "relative",
  display: "block",
  border: `${theme.sizes.borderWidth[1]} solid ${theme.colors.border.primary}`,
  borderBottom: "none",
  borderLeft: "none",
  borderRight: "none",
  /* width: 100%; */
  left: theme.sizes.spacing.none
}));
const stringify = (input) => {
  if (input === null || input === void 0) return "";
  if (typeof input === "string") return input;
  if (typeof input === "number" || typeof input === "boolean") return input.toString();
  return JSON.stringify(input, null, 2);
};
const Text = (t0) => {
  const $ = c(11);
  const {
    text,
    help: t1,
    variant: t2,
    isMarkdown: t3,
    isFooter: t4,
    component: t5,
    helpContent
  } = t0;
  const help = t1 === void 0 ? null : t1;
  const variant = t2 === void 0 ? "body2" : t2;
  const isMarkdown = t3 === void 0 ? false : t3;
  const isFooter = t4 === void 0 ? false : t4;
  const component = t5 === void 0 ? "span" : t5;
  if (!text) {
    let t62;
    if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
      t62 = /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "20%", height: 20 });
      $[0] = t62;
    } else {
      t62 = $[0];
    }
    return t62;
  }
  const Wrapper = isFooter ? asFooter : Fragment;
  let t6;
  if ($[1] !== component || $[2] !== help || $[3] !== helpContent || $[4] !== isMarkdown || $[5] !== text || $[6] !== variant) {
    t6 = isMarkdown ? /* @__PURE__ */ jsx(Markdown, { options: {
      forceBlock: true,
      wrapper: "div",
      overrides: {
        p: {
          component: Typography,
          props: {
            variant: variant || "subtitle1",
            sx: {
              whiteSpace: "pre-line",
              p: 0,
              m: 0
            }
          }
        }
      }
    }, children: text }) : /* @__PURE__ */ jsxs(Typography, { component, variant: variant || "subtitle1", noWrap: true, children: [
      stringify(text),
      help && isCmsTag(help) && helpContent && /* @__PURE__ */ jsx(Tooltip, { title: helpContent.label, placement: "top", children: /* @__PURE__ */ jsx(StyledHelpIcon, { onClick: () => helpContent.onClick(help.key) }) }),
      help && !isCmsTag(help) && /* @__PURE__ */ jsx(Tooltip, { title: stringify(help), placement: "top", children: /* @__PURE__ */ jsx(StyledHelpIcon, {}) })
    ] });
    $[1] = component;
    $[2] = help;
    $[3] = helpContent;
    $[4] = isMarkdown;
    $[5] = text;
    $[6] = variant;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== Wrapper || $[9] !== t6) {
    t7 = /* @__PURE__ */ jsx(Wrapper, { children: t6 });
    $[8] = Wrapper;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export {
  Text as default
};
